/**
 * `/admin` is where people look for administration; on a deployment it is the
 * operator dashboard, served beside the app at /dashboard/ (CloudFront routes
 * that prefix to its own bundle, and the dashboard does its own sign-in
 * bounce). Without this, tileriver.com/admin fell through to the app, which
 * has no such route and showed React Router's raw error screen.
 */
export const DASHBOARD_PATH = '/dashboard/';

/** `p` is the app path, base prefix already stripped. */
export function isAdminPath(p: string): boolean {
  return p === '/admin' || p.startsWith('/admin/');
}
